export type Tiers = "plus" | "premium" | "pv";

export const TIER_FEATURE_KEYS: Record<Tiers, string[]> = {
  plus: ["advancedEnergy", "customDashboards", "prioritySupport"],
  premium: ["realtimeMonitoring", "aiOptimization", "dedicatedManager"],
  pv: ["yieldSimulation", "shadingAnalysis", "profitabilityAssessment"],
};

export const REFETCH_INTERVAL = 3000;
